var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'adoc--preview ' + _vm.theme,domProps:{"innerHTML":_vm._s(_vm.renderedBody)}})}
var staticRenderFns = []

export { render, staticRenderFns }